export const useStatus = () => {
  const getClassName = (status, isMine = false) => {
    if (isMine) {
      return 'bg-white'
    } else if (!isMine) {
      return 'bg-blue btn-filled'
    }
    switch (status) {
      case 0: // 未作成
        return 'white-icon'
      case 1: // 作成中
        return ''
      case 2: // 自分への確認待ち
        return ''
      case 3: // 自分への差し戻し
        return ''
      case 4: // 完了
        return 'bg-blue btn-filled'
      case 5: // 自分が承認済
        return 'bg-blue btn-filled'
      case 6: // まだ自分の番じゃない承認待ち
        return 'bg-blue btn-filled'
      case 7: // 自分以外の再確認対応待ち
        return 'bg-blue btn-filled'
      case 8: // 未作成
        return 'white-icon'
      default:
        return 'border-dotted'
    }
  }

  const getIcon = status => {
    switch (status) {
      case 0:
        return require('@/assets/icons/edit-white-circle.svg')
      case 1: // edit
        return require('@/assets/icons/edit-circle.svg')
      case 2: // wait
        return require('@/assets/icons/wait-yellow.svg')
      case 3: // reject
        return require('@/assets/icons/rejected.svg')
      case 4: // approval
        return require('@/assets/icons/approved.svg')
      case 5: // 自分が承認済
        return require('@/assets/icons/approved-wait.svg')
      case 6: // まだ自分の番じゃない承認待ち
        return require('@/assets/icons/wait-yellow.svg')
      case 7: // まだ自分の番じゃない承認待ち
        return require('@/assets/icons/rejected.svg')
      case 8:
        return require('@/assets/icons/edit-white-circle.svg')
      default:
        return require('@/assets/icons/edit-circle.svg') //editと同じにする
    }
  }

  return { getIcon, getClassName }
}
